import type { WorkflowRunStatus } from '@/types';

export const workflowRunStatusFilterOptions: { value: WorkflowRunStatus | ''; label: string }[] = [
  { value: '', label: 'All Statuses' },
  { value: 'Running', label: 'Running' },
  { value: 'Completed', label: 'Completed' },
  { value: 'Failed', label: 'Failed' },
  { value: 'AwaitingApproval', label: 'Awaiting Approval' },
  { value: 'AwaitingUserInput', label: 'Awaiting Input' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Pending', label: 'Pending' },
]

export const workflowRunStatusProgressColors: Record<WorkflowRunStatus, string> = {
  Completed: 'bg-success-foreground',
  Running: 'bg-info-foreground',
  AwaitingApproval: 'bg-warning-foreground',
  AwaitingUserInput: 'bg-warning-foreground',
  Pending: 'bg-neutral-foreground',
  Failed: 'bg-danger-foreground',
  Cancelled: 'bg-cancelled-foreground',
}
